/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ActionContext from './ActionContext';

/**
 * The IUrlHelper model module.
 * @module model/IUrlHelper
 * @version V1
 */
class IUrlHelper {
    /**
     * Constructs a new <code>IUrlHelper</code>.
     * @alias module:model/IUrlHelper
     */
    constructor() { 
        
        IUrlHelper.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>IUrlHelper</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IUrlHelper} obj Optional instance to populate.
     * @return {module:model/IUrlHelper} The populated <code>IUrlHelper</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IUrlHelper();

            if (data.hasOwnProperty('actionContext')) {
                obj['actionContext'] = ActionContext.constructFromObject(data['actionContext']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>IUrlHelper</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>IUrlHelper</code>.
     */
    static validateJSON(data) {
        // validate the optional field `actionContext`
        if (data['actionContext']) { // data not null
          ActionContext.validateJSON(data['actionContext']);
        }

        return true;
    }


}



/**
 * @member {module:model/ActionContext} actionContext
 */
IUrlHelper.prototype['actionContext'] = undefined;






export default IUrlHelper;

